import { createTranslations } from '@npco/utils-translations'

export const transferConfirmationHeaderTranslations = createTranslations({
  transferring: 'Transferring...',
  title: 'Transfer Confirmed',
  showDetailsText: 'Show Details',
  hideDetailsText: 'Hide Details',
})
